import React, { memo } from "react";
import QrPattern from "./qrPattern";
import CornersWrapper from "../CornersWrapper";
import QrBackground from "./qrBackground";
import ErrorLevel from "./qrPattern/errorLevel";
import { useSelector } from "react-redux";
import { designTypes } from "../../../../constants/common";

function ShapeColorWrapper() {
  const designType = useSelector((state) => state.customizeQr.designType);
  return (
    <>
      <section
        className="bg-white p-3 p-md-4 mt-3 mt-lg-4 text-capitalize rounded-1"
        id="shape"
      >
        <QrPattern />
      </section>
      {designType === designTypes.base && (
        <section className="bg-white p-3 p-md-4 text-capitalize rounded-1 mt-3 mt-lg-4">
          <ErrorLevel />
        </section>
      )}
      <section className="mt-3 mt-lg-4">
        <CornersWrapper />
      </section>
      {designType === designTypes.base && (
        <section className="bg-white p-3 p-md-4 mt-3 mt-lg-4 text-capitalize rounded-1">
          <QrBackground />
        </section>
      )}
    </>
  );
}

export default memo(ShapeColorWrapper);
